<soft-op-diagram-tabelle-view
  [offenePosten]="offenePosten()"
  [loading]="loading()"
  [title]="'#OFFENE_POSTEN.TITLE'"
  [subtitle]="'#OFFENE_POSTEN.SUB_TITLE'">
</soft-op-diagram-tabelle-view>
